<template>
  <v-toolbar class="fullToolbar">
    <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
      <i class="material-icons icon">recent_actors</i>
      {{$t('projects')}}
      <v-btn fab light small color="primary" title="הוסף חדש" v-on:click.native="isNew=true" style="width: 30px; height: 30px;">
        <v-icon dark>add</v-icon>
      </v-btn>
      <v-btn light small color="primary" style="width: 120px; height: 30px;">
        <v-icon dark>list</v-icon>הצג רשימה
      </v-btn>
      <v-btn light small color="primary" style="width: 120px; height: 30px;">
        <v-icon dark>place</v-icon>הצג מפה
      </v-btn>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-text-field dark prepend-icon="search" single-line style="padding-top: 20px; text-align:center!important;" v-model="txtSearch"></v-text-field>
  </v-toolbar>
</template>

<script>

  import imgUser from '../assets/user.png';

  export default {
    name: 'Customers',
    data() {
      return {
        txtSearch: '',
        isDelete: false,
        isEdit: false,
        isNew: false,
        selectedRow: {
          customerId: 0,
          customerApiKey: "",
          clubName: "",
          address: "",
          logo: "",
          banner: "",
          expiredDate: "",
          expiredDateStr: ""
        },
      }
    },
    created() {
      this.$Log("Vue [Customers] is created ...");
    },
    ready() {
      this.$Log("Vue [Customers] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Customers] is mounted ...");
      var vm = this;
      vm.$GetCustomers(vm, function (result) {
        vm.$Log("$GetCustomers result >> " + JSON.stringify(result));
        if (result.success) {
          if (result.data != "null") {
            vm.$root.customersList = JSON.parse(result.data);
          }
          else {
            vm.error = "Login failed! Wrong username or password!";
          }
        }
        else {
          vm.error = "Login failed! Wrong username or password!";
        }
      });
    },
    updated() {
      this.$Log("Vue [Customers] is updated ...");
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      showForm() {
        return (this.isEdit || this.isNew);
      },
      filteredRows() {
        var vm = this;
        if (vm.txtSearch.length > 0) {
          var result = [];
          try {
            var rowsCount = 0;
            result = vm.$root.customersList.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (key != "logo") {
                  if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                    rowsCount++;
                    return row;
                  }
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          var result = vm.$root.customersList;
        }

        return result;
      }
    },
    methods: {
      selectFile(e) {
        var vm = this;

        var files = e.target.files || e.dataTransfer.files;

        if (!files.length) {
          vm.file = null;
        }
        else {
          var fileType = files[0].name.split('.').pop();
          if (fileType.toLowerCase() == 'png' || fileType.toLowerCase() == 'jpg' || fileType.toLowerCase() == 'jpeg') {
            vm.file = files[0];
            var reader = new FileReader();
            reader.onload = (ev) => {
              vm.imgAccountAvt = ev.target.result;
            };
            reader.readAsDataURL(vm.file);
          }
          else {
            vm.file = null;
            vm.$root.alert.message = 'Please select image only (*.jpg/*.jpeg/*.png)!!';
            vm.$root.alert.isShow = true;
          }
        }
      },
      edit(row) {
        this.selectedRow = row;
        this.selectedRow = {
          customerId: row.customerId,
          customerApiKey: row.customerApiKey,
          clubName: row.clubName,
          address: row.address,
          logo: row.logo,
          banner: row.banner,
          expiredDate: row.expiredDate,
          expiredDateStr: row.expiredDateStr
        };
        this.isEdit = true;
      },
      confirm(row) {
        this.selectedRow = {
          customerId: row.customerId,
          customerApiKey: row.customerApiKey,
          clubName: row.clubName,
          address: row.address,
          logo: row.logo,
          banner: row.banner,
          expiredDate: row.expiredDate,
          expiredDateStr: row.expiredDateStr
        };
        this.isDelete = true;
      },
      remove() {
      },
      cancel() {
        this.selectedRow = {
          customerId: 0,
          customerApiKey: "",
          clubName: "",
          address: "",
          logo: "",
          banner: "",
          expiredDate: "",
          expiredDateStr: ""
        };
      },
      uploadImage(vm, accountId, callback) {
        var uploadData = new FormData();
        uploadData.append("accountId", accountId);
        uploadData.append("file", vm.file);

        vm.$UploadAccountImage(uploadData, function (uploadResult) {
          callback(uploadResult);
        });
      },
      isValid(isNew) {
        if (this.account.email != undefined) {
          if (this.account.email.trim().length == 0) {
            this.$root.alert.message = this.$t('missingEmail');//'Please enter Email!';
            this.$root.alert.isShow = true;
            return false;
          }
        }
        else {
          this.account.email = "";
        }

        if (isNew) {
          if (this.account.communityId != undefined) {
            this.account.communityId = this.account.communityId + "";
            if (this.account.communityId.trim().length == 0) {
              this.$root.alert.message = this.$t('missingCommunity');//'Please enter Community Id!';
              this.$root.alert.isShow = true;
              return false;
            }
          }
          else {
            this.account.communityId = "";
            this.$root.alert.message = this.$t('missingCommunity');//'Please enter Community Id!';
            this.$root.alert.isShow = true;
            return false;
          }
        }

        if (this.account.name != undefined) {
          if (this.account.name.trim().length == 0) {
            this.$root.alert.message = this.$t('missingName');//'Please enter Name!';
            this.$root.alert.isShow = true;
            return false;
          }
        }
        else {
          this.account.name = "";
          this.$root.alert.message = this.$t('missingName');//'Please enter Name!';
          this.$root.alert.isShow = true;
          return false;
        }

        return true;
      },
      reset() {
        this.title = "";
        this.activeTab = 'tab1';
        this.placeIndex = -1;
        this.selectedTab = null;
        this.places = [];
        this.cities = [];
        this.account = {
          name: '',
          email: '',
          communityId: '',
          description: '',
          language: '',
          places: [],
          cities: [],
          joinKey: '',
          invitationTypes: []
        };
      },
    }
  }

</script>
<style></style>



// WEBPACK FOOTER //
// Toolbar.vue?4473419b